import {Component, Input} from '@angular/core';
import {User} from "../../princial.service";
import {MsalService} from "@azure/msal-angular";
import {MatIcon} from "@angular/material/icon";
import {MatDivider} from "@angular/material/divider";
import {MatTooltip} from "@angular/material/tooltip";
import {TranslatePipe} from "@ngx-translate/core";

interface UserView {
  fullName: string,
  email: string,
  roles: string[],
}

@Component({
  selector: 'roaming-user',
  templateUrl: './user.component.html',
  styleUrls: ['./user.component.css'],
  imports: [MatIcon, MatDivider, MatTooltip, TranslatePipe]
})
export class UserComponent {

  user: UserView = {} as UserView;

  constructor(private readonly authService: MsalService) {
  }

  @Input()
  set userData(value: User | null) {
    if (value) {
      this.user.fullName = value.name;
      this.user.email = value.email;
      this.user.roles = value.authorities;
    }
  }

  getRolesCount(): number {
    return this.user.roles?.length;
  }

  getRoles(): string {
    return [...(this.user.roles ?? [])].sort((a, b) => a.localeCompare(b)).join(',\n');
  }

  logout(): void {
    this.authService.logoutPopup({mainWindowRedirectUri: '/ui/logout'});
  }
}
